import { ChangeDetectionStrategy, Component } from '@angular/core';
import {Footer} from '../footer/footer';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.html',
  styleUrl: './not-found.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    Footer
  ]
})
export class NotFoundPage {}
